import { render } from "./AddBescPricingRulePage.vue?vue&type=template&id=b7a22748&ts=true"
import script from "./AddBescPricingRulePage.vue?vue&type=script&lang=ts"
export * from "./AddBescPricingRulePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__